'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';
import { MarketingAtmosphere } from '@/components/piai/shell/MarketingAtmosphere';
import '@/styles/piai.css';

const NAV = [
  { href: '/how-we-work', label: 'How we work' },
  { href: '/pricing', label: 'Pricing' },
  { href: '/signin', label: 'Sign in' },
];

export function MarketingShell({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  const isAuthPage = pathname === '/signin' || pathname === '/signup';

  return (
    <div className="piai piai-shell piai-marketing">
      <MarketingAtmosphere />
      <header className="piai-topbar piai-mkt-topbar">
        <Link href="/" className="piai-brand">
          <span className="piai-brand-name">PIAI</span>
          <span className="piai-brand-tag">keeps your month moving</span>
        </Link>
        <nav className="piai-nav" aria-label="Marketing">
          {NAV.map((item) => {
            const active =
              pathname === item.href || pathname.startsWith(`${item.href}/`);
            return (
              <Link
                key={item.href}
                href={item.href}
                data-active={active ? 'true' : 'false'}
              >
                {item.label}
              </Link>
            );
          })}
          {!isAuthPage && (
            <Link href="/signup" className="piai-btn piai-btn-primary ml-1">
              Get started
            </Link>
          )}
        </nav>
      </header>
      <main className="piai-main piai-mkt-main">{children}</main>
      <footer className="piai-mkt-footer">
        <div className="mx-auto flex max-w-5xl flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <p className="piai-display text-lg">PIAI</p>
          <nav
            className="flex flex-wrap gap-x-5 gap-y-2 text-sm opacity-80"
            aria-label="Footer"
          >
            <Link href="/how-we-work">How we work</Link>
            <Link href="/pricing">Pricing</Link>
            <Link href="/terms">Terms</Link>
            <Link href="/privacy">Privacy</Link>
            <Link href="/signin">Sign in</Link>
          </nav>
        </div>
      </footer>
    </div>
  );
}
